export const DEFAULT_TABS = [
  { key: "overzicht", label: "Overzicht" },
  { key: "details", label: "Details" },
  { key: "commercieel", label: "Commercieel" },
  { key: "contactpersonen", label: "Contactpersonen" },
  { key: "leveranciers", label: "Leveranciers" },
  { key: "assets", label: "Assets" },
  { key: "werkbonnen", label: "Werkbonnen" },
  { key: "communicatie", label: "Klantcommunicatie" },
  { key: "documenten", label: "Documenten" },
  { key: "portaaltoegang", label: "Portaaltoegang" },
  { key: "taken-notities", label: "Taken en notities" },
];

export default function ClientTabs({ activeTab, onChange, tabs = DEFAULT_TABS }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white px-2 py-2 shadow-sm">
      <nav className="flex min-w-max gap-2">
        {tabs.map((tab) => (
          <button
            type="button"
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={`rounded-lg px-4 py-2 text-sm font-medium transition ${
              activeTab === tab.key
                ? "bg-slate-900 text-white"
                : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
